import { UPLOAD_STRINGS } from "@/lib/uploadI18n";

// Compact busy copy avoids width problems in narrow setup cards and keeps the
// same concise status across every viewport and supported interface language.
export const BUSY_COPY = {
  en: "Generating…",
  "pt-BR": "Gerando…",
  "es-419": "Generando…",
  "fr-CA": "Génération…",
};

for (const [lang, label] of Object.entries(BUSY_COPY)) {
  if (UPLOAD_STRINGS[lang]) {
    UPLOAD_STRINGS[lang].jdGenBusy = label;
  }
}
